import { Box, Divider, InputAdornment } from '@mui/material';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormNumberInput } from '../../../../../component/form/FormNumberInput';
import { FinancesDrawerFormValues } from '../RightDrawerSchema';

type Props = {
  control: Control<FinancesDrawerFormValues>;
};

export const FinancesNormalPriceView = ({ control }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <Box sx={{ ml: '8%' }}>
        <FormNumberInput
          control={control}
          name="service.apiconPriceForm.priceGross"
          label=""
          helperText={t('deals.new.financesConfiguration.calculationDrawer.rate.rateIncludingVAT')}
          startAdornment={<InputAdornment position="start">€</InputAdornment>}
          shrink
          disableUnderline
          disabled
        />
      </Box>

      <Divider orientation="vertical" flexItem />

      <Box sx={{ ml: '8%' }}>
        <FormNumberInput
          control={control}
          name="service.apiconPriceForm.priceNet"
          label=""
          helperText={t('deals.new.financesConfiguration.calculationDrawer.rate.rateExcludingVAT')}
          startAdornment={<InputAdornment position="start">€</InputAdornment>}
          shrink
          disableUnderline
          disabled
        />
      </Box>

      <Divider orientation="vertical" flexItem />

      <Box sx={{ ml: '8%' }}>
        <FormNumberInput
          control={control}
          name="service.apiconPriceForm.vatAsValue"
          label=""
          helperText={t('deals.new.financesConfiguration.calculationDrawer.rate.VAT')}
          startAdornment={<InputAdornment position="start">€</InputAdornment>}
          shrink
          disableUnderline
          disabled
        />
      </Box>
    </>
  );
};
